import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import {
    ALERT_INBOX_DROPDOWN_FILTER_TOKEN,
    ALERT_INBOX_MODES_TOKEN,
    PRODUCT_DOMAIN
} from "@app2/alert/alert-inbox/injection-tokens";
import { InboxDropdownFilterType, ModeType, StateParams } from "@app2/fraud/type-defs";
import { DropdownOption } from "@app2/shared/predicate-dropdown-menu.component";
import { RouterService } from "@app2/shared/services/router.service";
import { Keys, StorageService } from "@app2/shared/services/storage.service";
import { Domain } from "@app2/alert/constants";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "alert-inbox-header",
    template: `
        <pr-dropdown test-class="mode-dropdown">
            <div pr-dropdown-trigger>
                <span class="dropdown-value">{{ selectedModeOption.key | localize | uppercase }}</span>
                <i class="far fa-chevron-down"></i>
            </div>

            <ul pr-dropdown-body>
                <li *ngFor="let option of modeOptions"
                    [class.active]="option.value === selectedModeOption.value"
                    (click)="selectMode(option)">
                    <i class="far fa-check"></i>
                    {{ option.key | localize }}
                </li>
            </ul>
        </pr-dropdown>
        <pr-dropdown *ngIf="selectedMode !== 'alert_story'" class="pr-dropdown-padding"
            test-class="inboxfilter-dropdown">
            <div pr-dropdown-trigger>
                <span class="dropdown-value">{{ selectedDropdownFilterOption.key | localize | uppercase }}</span>
                <i class="far fa-chevron-down"></i>
            </div>

            <ul pr-dropdown-body>
                <li *ngFor="let option of dropdownFilterOptions"
                    [class.active]="option.value === selectedDropdownFilterOption.value"
                    (click)="selectDropdownFilter(option)">
                    <i class="far fa-check"></i>
                    {{ option.key | localize }}
                </li>
            </ul>
        </pr-dropdown>
    `,
})
export class AlertInboxHeaderComponent implements OnChanges {
    @Input() selectedDropdownFilter: InboxDropdownFilterType;
    @Input() selectedMode: ModeType;

    selectedDropdownFilterOption: DropdownOption<InboxDropdownFilterType>;
    selectedModeOption: DropdownOption<ModeType>;

    constructor(@Inject(PRODUCT_DOMAIN) private productDomain: Domain,
                @Inject(ALERT_INBOX_DROPDOWN_FILTER_TOKEN) public dropdownFilterOptions: DropdownOption<InboxDropdownFilterType>[],
                @Inject(ALERT_INBOX_MODES_TOKEN) public modeOptions: DropdownOption<ModeType>[],
                private readonly router: RouterService,
                private storageService: StorageService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedDropdownFilter) {
            this.selectedDropdownFilterOption = this.dropdownFilterOptions.find(option => option.value === this.selectedDropdownFilter);
        }
        if (changes.selectedMode) {
            this.selectedModeOption = this.modeOptions.find(option => option.value === this.selectedMode);
            if (this.productDomain === "FRAUD") {
                this.modeOptions = this.modeOptions.filter(option => option.value !== "alert");
            }
        }
    }

    selectDropdownFilter(selected: DropdownOption<InboxDropdownFilterType, InboxDropdownFilterType>) {
        if (this.selectedDropdownFilter === selected.value) {
            return;
        }

        this.storageService.set(Keys.alertInboxDropdownFilter, selected.value);

        this.router.mergeParams<StateParams>({
            dropdownFilter: selected.value,
            selected: undefined,
        });
    }

    selectMode(selected: DropdownOption<ModeType, ModeType>) {
        if (this.selectedMode === selected.value) {
            return;
        }

        this.router.mergeParams<StateParams>({
            mode: selected.value,
            selected: undefined,
        });
    }
}
